<template>
	<header class="video-header" :class="type">
		<slot name="heroContent" />
		<div class="video-container">
			<div class="video-block">
				<iframe
					id="embed-desktop"
					:src="`https://player.vimeo.com/video/${embedCode}?loop=1&muted=1&badge=0&autoplay=1&controls=0&autopause=0&player_id=0`"
					frameborder="0"
					loading="lazy"
					class="youtube-player"
					allow="autoplay"
					allowfullscreen
				></iframe>
			</div>
		</div>
	</header>
</template>

<script setup>
defineProps({
	embedCode: { type: String, default: '' },
	type: { type: String, default: 'small' },
});
</script>

<style lang="scss" scoped>
header.large {
	height: 100vh;
}

header.small {
	height: 70vh;
}

.video-header {
	width: 100%;
	position: relative;
	overflow: hidden;
}

.video-container {
	overflow: hidden;
	position: relative;
	height: 100%;
}

.video-block {
	container-type: size;
	position: absolute;
	inset: 0;
	width: 100%;
	height: 100%;
}

.video-block iframe {
	position: absolute;
	top: 50%;
	left: 50%;
	transform: translate(-50%, -50%);
	width: 100%;
	height: 100%;
	margin: 0 auto;
}

@container (min-aspect-ratio: 16 / 9) {
	.video-block iframe {
		height: 56.25cqw;
	}
}

@container (max-aspect-ratio: 16 / 9) {
	.video-block iframe {
		width: 177.78cqh;
	}
}

@media (max-width: 880px) {
	header.large {
		height: 100vh;
	}

	header.small {
		height: 60vh;
	}
}
</style>
